import * as DatabaseActions from '~app/actions/database';
import makeReducer from '~app/core/makeReducer';

const initialState = {
  cellIdMap: null,
  imageSheets: [],
};

function loadCellIdMap(state, {cellIdMap}) {
  return {
    ...state,
    cellIdMap,
  };
}

function loadedImageSheets(state, {imageSheets}) {
  return {
    ...state,
    imageSheets,
  };
}

const ACTION_HANDLERS = {
  [DatabaseActions.LOAD_CELL_ID_MAP]: loadCellIdMap,
  [DatabaseActions.LOADED_IMAGE_SHEETS]: loadedImageSheets,
};

export default makeReducer(ACTION_HANDLERS, initialState);



// WEBPACK FOOTER //
// ./src/store/databaseReducer.js